module.exports = __webpack_public_path__ + "img/en.74892197.svg";